module.exports = "/images/PrestaShop.png?e1a5f9c2894ff74df742e268d673f095";